<template>
  <div class="consluatationCount">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>统计分析</el-breadcrumb-item>
          <el-breadcrumb-item>会诊统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>会诊统计</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input v-model="keyword"
                  size="small"
                  placeholder="请输入医生姓名/工号"
                  width="264"
                  class="key-word"></el-input>
        <span>年份/月份:</span>
        <el-date-picker v-model="date" value-format="yyyy-MM"
                        type="month"
                        placeholder="请选择">
        </el-date-picker>
        <el-button class="search"
                   type="primary"
                   size="small"
                   @click="search">查询</el-button>
        <el-button size="small"
                   @click="reset">重置</el-button>
      </div>
      <div class="table">
        <template>
          <el-table :data="tableData" v-if="isApplyDocList" v-loading="loading"
                    style="width:100%;"
                    border>
            <el-table-column label="序号"
                             prop="id"
                             align="center"
                             fixed>
            </el-table-column>
            <el-table-column label="申请科室"
                             prop="appleDept"
                             align="center"
                             fixed>
            </el-table-column>
            <el-table-column align="right"
                             width="180">
              <template slot="header" slot-scope="scope">
                <el-select size="small" class="apply-doc-header" style="margin-top:5px;padding-left:0px;padding-right:0px;" @change="changeApplyDoc"
                           v-model="applyDoc"
                           clearable
                           placeholder="申请医生">
                  <el-option v-for="item in applyDocList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope">
                <span style="text-align:left;display:inline-block;width:100%;">{{scope.row.appleDoctor}}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请时间"
                             align="center"
                             prop="appleDate"
                             width="150">
            </el-table-column>
            <el-table-column label="病人姓名"
                             align="center"
                             prop="patientName">
            </el-table-column>
            <el-table-column label="病人年龄"
                             align="center"
                             prop="patientAge">
            </el-table-column>
            <el-table-column label="病人性别"
                             align="center"
                             prop="patientSex">
            </el-table-column>
            <el-table-column label="身份证号"
                             prop="patientIDNumber"
                             width="165">
            </el-table-column>
            <el-table-column label="病人电话"
                             width="150"
                             prop="patientTel">
            </el-table-column>
            <el-table-column label="初诊诊断"
                             width="200"
                             prop="firstVisit">
            </el-table-column>
            <el-table-column label="会诊时间"
                             align="center"
                             prop="diagnosis"
                             width="150">
            </el-table-column>
            <el-table-column label="申请类别"
                             align="center"
                             prop="applyType">
            </el-table-column>
            <el-table-column label="会诊科室"
                             prop="diagnosisDept">
            </el-table-column>
            <el-table-column label="会诊医师姓名"
                             align="center"
                             prop="diagnosisDoctor">
            </el-table-column>
            <el-table-column label="会诊医师工号"
                             align="center"
                             prop="diagnosisWorkNum">
            </el-table-column>
            <el-table-column label="职称"
                             align="center"
                             prop="diagnosisProfessional">
            </el-table-column>
            <el-table-column label="会诊后诊断"
                             prop="nextDiagnosis"
                             width="200">
            </el-table-column>
            <el-table-column label="计费"
                             align="center"
                             prop="charging">
            </el-table-column>
            <el-table-column label="是否转院"
                             align="center"
                             prop="transfer">
            </el-table-column>
            <el-table-column label="转院时间"
                             align="center"
                             prop="transferDate"
                             width="150">
            </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="page">
        <el-pagination @size-change='handleSizeChange'
                       @current-change='handleCurrentChange'
                       :current-page.sync='pageIndex'
                       :page-sizes='[10, 20, 50]'
                       :page-size='pageSize'
                       layout='total, sizes, prev, pager, next, jumper'
                       :total='total'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      keyword: "",
      date: "",
      tableData: [],
      applyDocList: [],
      applyDoc: '',
      isApplyDocList: false,
      loading: true
    };
  },
  created() {
    this.getApplyDocList()
  },
  methods: {
    changeApplyDoc(val) {
      this.keyword = val
      this.getTableData(this.pageIndex, this.pageSize, this.keyword, this.date);
    },
    getApplyDocList() {
      this.Axios.get('/api/User/GetUserList').then(res => {
        if (res.data.status === 100) {
          for (let item of res.data.data) {
            this.applyDocList.push({
              label: item,
              value: item
            })
          }
          this.$nextTick(() => {
            this.isApplyDocList = true
            this.getTableData(this.pageIndex, this.pageSize)
          })
        }
      })
    },
    search() {
      if (this.keyword || this.date) {
        this.getTableData(this.pageIndex, this.pageSize, this.keyword, this.date);
      }
    },
    reset() {
      this.keyword = ''
      this.date = ''
      this.applyDoc = ''
      this.pageIndex = 1
      this.pageSize = 10
      this.getTableData(this.pageIndex, this.pageSize);
    },
    handleSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.getTableData(this.pageIndex, pagesize);
    },
    handleCurrentChange(start) {
      this.pageIndex = start;
      this.getTableData(start, this.pageSize);
    },
    getTableData(start, pagesize, keyword, date) {
      this.loading = true
      let params = {
        start: start,
        pagesize: pagesize
      }
      if (keyword != undefined) {
        params.keyword = keyword;
      }
      if (date != undefined) {
        params.date = date;
      }
      this.Axios.get("/api/Statistics/Consultation", { params })
        .then(res => {
          const data = res.data
          if (data.status == 100) {
            this.tableData = data.data;
            this.total = data.total;
            this.loading = false
          } else if (data.Status == 400) {
            this.$message({
              showClose: true,
              message: data.Message,
              type: "error"
            })
          } else {
            this.$message({
              showClose: true,
              message: data.message,
              type: "error"
            })
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  }
};
</script>

<style lang="less">
.consluatationCount {
  .table-info {
    .breadcrumb {
      overflow: hidden;
      span,
      .el-breadcrumb {
        float: left;
      }
      span {
        font-size: 14px;
        color: #666;
        line-height: 1;
      }
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      .search {
        margin-left: 20px;
        span {
          color: white;
        }
      }
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .date {
        width: 264px;
        margin-right: 20px;
      }
    }
    .table {
      margin-top: 40px;
      .apply-doc-header {
        .el-input {
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
      }
    }
    .page {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Statistics/ConsluatationCount.vue